import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Formik, Field } from 'formik';
import { PostFormSchema } from '../../schemas/PostSchema';
import { observer } from 'mobx-react-lite';
import { TextField } from 'formik-material-ui';
import { makeStyles } from '@material-ui/core/styles';
import DatePicker from '../../components/DatePicker';

import User from '../../singletons/User';
import { Button, Grid } from '@material-ui/core';
import { format } from 'date-fns';

const initialValues = Object.freeze({
  date: new Date(),
  location: '',
  logs: []
});

const AddPost = props => {
  const classes = useStyles();

  // useEffect(() => {
  //   User?.user?.posts?.refetch();
  // }, []);

  const handleSubmit = useCallback(async (values, form) => {
    const post = { ...values };
    post.date = format(values.date, 'yyyy-MM-dd');
    const success = await User.user?.posts?.addPost(post);
    if (success) {
      props.onComplete?.()
    }
  }, [props.onComplete]);

  return (
    <Formik
      onSubmit={handleSubmit}
      initialValues={initialValues}
      validationSchema={PostFormSchema}>
      {
        renderProps => {
          const { handleSubmit, values, isValid, errors, dirty } = renderProps;
          console.log({ errors, isValid, values });
          return (
            <form className={classes.form} onSubmit={handleSubmit}>
              <Grid container spacing={3} alignItems={'center'} justifyContent={'center'}>
                <Grid item xs={12}>
                  <Field
                    name={'date'}
                    label={'Date'}
                    component={ DatePicker }
                  />
                </Grid>
                <Grid item xs={12}>
                  <Field
                    fullWidth
                    variant={'outlined'}
                    label={'Location'}
                    value={values.location}
                    component={TextField}
                    name={'location'}
                  />
                </Grid>
                <Grid item>
                  <Button
                    className={classes.cancel}
                    fullWidth
                    variant={'outlined'}
                    onClick={props.onCancel}>
                    Cancel
                  </Button>
                </Grid>
                <Grid item className={classes.container}>
                  <Button
                    className={classes.save}
                    fullWidth
                    variant={'contained'}
                    type={'submit'}
                    color={'primary'}
                    disabled={!dirty || !isValid}>
                    Save
                  </Button>
                </Grid>
              </Grid>
            </form>
          );
        }
      }
    </Formik>
  );
};

AddPost.propTypes = {

};

const useStyles = makeStyles(
  theme => {
    return {
      form: {
        maxWidth: 400,
        margin: 'auto',
      },
      container: {
        flex: 1,
      },
      save: {
        color: 'white',
        flexGrow: 1,
      },
      cancel: {
        // borderColor: 'red'
      }
    };
  }
);

export default observer(AddPost);
